
import { PlatformsSectionProps } from './types';
import PlatformCard from './PlatformCard';

const PlatformsSection = ({ 
  title, 
  platforms, 
  onSelectPlatform, 
  isNew 
}: PlatformsSectionProps) => {
  return (
    <section className="mb-8">
      <div className="flex items-center mb-4">
        <h3 className="text-base font-medium text-custom-dark dark:text-gray-100">{title}</h3>
        {isNew && (
          <span className="ml-2 text-xs bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 rounded-full px-2 py-1">Nouveau</span>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {platforms.map(platform => (
          <PlatformCard 
            key={platform.id} 
            platform={platform} 
            onSelect={onSelectPlatform} 
          />
        ))}
      </div>
    </section>
  );
};

export default PlatformsSection;
